export const DEFAULT_FORM_VALUES = {
	activity: '',
	executingDateTime: '',
	executingDateTimeWithParameter: '',
	action: '',
	isEdit: false,
	isEnableDropDown: false,
};
